import { TFunctionResult } from 'i18next'
import React from 'react'
import { useCookies } from 'react-cookie'
import { useTranslation } from 'react-i18next'

import Box, { BoxProps } from '@/modules/components/Box'
import Flex from '@/modules/components/Flex'
import Typography from '@/modules/components/Typography'
import { i18nLanguageToDisplayString } from '@/modules/utils'

type LangMenuProps = {
  suggestLangs: string[]
  allLangs: string[]
  onClick: (region: string) => void
} & Omit<BoxProps, 'onClick'>

export const LangMenu = ({
  suggestLangs,
  allLangs,
  onClick,
  ...restProps
}: LangMenuProps) => {
  const { t, i18n } = useTranslation('navigation')
  const { language: currentLanguage } = i18n
  const [, setCookie] = useCookies(['locale'])

  const renderLang = (language: string) => (
    <Flex
      key={language}
      onClick={() => {
        //  TODO improve lower case an upper case, cookie now is UPPERCASE❗️
        i18n.changeLanguage(language)
        setCookie('locale', language, {
          path: '/',
        })
        onClick(language.toUpperCase())
      }}
      justifyContent="flex-start"
      alignItems="center"
      width="calc(100% / 3)"
      borderRadius="8px"
      marginBottom={0.5}
      customCss={{
        '&:hover': {
          cursor: 'pointer',
          backgroundColor: '#EAEEF4',
          '.text': {
            textDecoration: 'underline',
          },
        },
      }}
    >
      <Typography
        variant="subtitle3"
        color={
          currentLanguage === language
            ? 'primaryBrightBlue'
            : 'primaryDeepBlack'
        }
        maxWidth={['200px', 'max-content']}
        className="text"
        paddingTop={1}
        paddingBottom="6px"
        paddingRight="6px"
        marginLeft={2}
      >
        {i18nLanguageToDisplayString(language)}
      </Typography>
      <Typography
        variant="subtitle4"
        color={currentLanguage === language ? 'primaryBrightBlue' : '#656E85'}
        opacity={currentLanguage === language ? 1 : 0.72}
      >
        {language.toUpperCase()}
      </Typography>
    </Flex>
  )

  const renderSection = (title: TFunctionResult, languages: string[]) =>
    languages && languages.length > 0 ? (
      <>
        <Typography variant="subtitle2" color="#000" marginBottom="20px">
          {title}
        </Typography>
        <Box display="flex" flexWrap="wrap" marginBottom={4}>
          {languages.map(renderLang)}
        </Box>
      </>
    ) : null

  return (
    <Box {...restProps}>
      {renderSection(t('geolocation.suggestion'), suggestLangs)}
      {renderSection(t('geolocation.allLang'), allLangs)}
    </Box>
  )
}
